import { useBreakPoints } from '@/hooks/use-break-points';
import Sidebar from '@/icons/Sidebar';
import { HeaderButton } from '@react-navigation/elements';
import { DrawerActions } from '@react-navigation/native';
import { useNavigation } from 'expo-router';
import { useCallback } from 'react';
import { Platform, View } from 'react-native';

export function coreLeftView() {
  return <LeftView />;
}

function LeftView() {
  const { isMobile } = useBreakPoints();

  const navigation = useNavigation();

  const openDrawer = useCallback(() => {
    navigation.dispatch(DrawerActions.toggleDrawer());
  }, [navigation]);

  return isMobile || Platform.OS !== 'web' ? (
    <HeaderButton tintColor="white" onPress={openDrawer}>
      <Sidebar size={32} color="white" />
    </HeaderButton>
  ) : (
    // just a little spacer for header padding
    <View className="h-4 w-4" />
  );
}
